import React, { useCallback } from "react"

import { DEFAULT_LANGUAGE, useBounceGlobalValues, useTranslation } from "@bounce/i18n"

import { Hero } from "./components/Hero"
import { CityList } from "@/components/Generic/CityList/CityList"
import { Layout } from "@/components/LuggageStorage/Layout/Layout"
import type { CityLink } from "@/libs/bounce/cities"
import type { AggregateRating } from "@/libs/bounce/types"
import { getCityUrlPath, useUrl } from "@/libs/router"

export type CitiesScreenProps = {
  cities: CityLink[]
  aggregateRating: AggregateRating
}

const CitiesScreen = ({ cities, aggregateRating }: CitiesScreenProps) => {
  const { t } = useTranslation("marketing-ls-cities")
  const { absolutePath } = useUrl()
  const bounceGlobals = useBounceGlobalValues()

  const mapCityToLink = useCallback(
    (city: CityLink) => ({
      name: city.translatedName,
      href: getCityUrlPath({ city: { ...city, directorySlug: "luggage-storage" } }),
      locale: DEFAULT_LANGUAGE,
    }),
    [],
  )

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: t("page.cities.metaTitleV4", "Bounce - See All {{numCities}}+ Cities Offering Luggage Storage", {
          numCities: bounceGlobals.numCities,
        }),
        description: t(
          "page.cities.metaDescription",
          "Bounce offers luggage storage on nearly every continent. Check out our latest Cities List to see if we're where you need us next!",
        ),
        noIndex: true,
      }}>
      <Hero aggregateRating={aggregateRating} />
      <CityList cities={cities} mapLinks={mapCityToLink} className="py-section" />
    </Layout>
  )
}

export default CitiesScreen
